import './projects.css'

const proj_info = require("../text.json") 

const Projects = () => {

    const projects = proj_info.project.map((proj) => {
        return ProjectContainer(proj)
    })

    return (
        <div className='projects-section'>
            <h1 className='header'>My Work</h1>
            <div className='divider'></div>

            <div className="projects container">
                {projects}
            </div>
        </div>
    )
}

const ProjectContainer = (props) => {
    return (
        <div className="project-container">
             <div className='icon-container'>
                <a href={props.link} className='icon zoom fas fa-link'>{}</a>
            </div>
        
            <div className="text-container">
                <div className='title'>{props.name}</div>
                <div className='subtitle'>{props.description}</div>
            </div>
            <div className="tech-stack">
                {props.techStack.map((str, idx) => {
                    return <p key={`${str}${idx}`}>{str}</p>
                })}
            </div>
        </div>
    )
}

export default Projects;
